<template>
    <div class="flex flex-col justify-start items-center max-w-2xl bg-white rounded-lg shadow-md mx-8 md:mx-auto my-12">
        <div class="pt-12 pb-8 px-12 bg-white shadow-md rounded-lg flex flex-col justify-start items-center gap-8 inline-flex">
            <!-- エラーメッセージ -->
            <ErrorMessage :message="errorMessage" @clear-message="errorMessage = ''" />

            <!-- タイトルとサブタイトル -->
            <div class="flex flex-col justify-start items-start gap-4 w-full text-center text-main">
                <div class="text-2xl font-semibold leading-8 break-words w-full">アカウントを作成する</div>
                <div class="text-sm font-light leading-5 break-words w-full">ECHOESアカウントを作成します。</div>
            </div>

            <!-- ガイドライン・規約 -->
            <div class="self-stretch flex flex-col justify-start items-start gap-6">
                <div class="self-stretch text-sm font-light leading-5 text-main break-words">
                    ご登録前には当サービスの
                    <a href="/guideline" target="_blank" class="link-styles">「ガイドライン」</a>
                    および、当社の
                    <a href="https://www.livedoor.com/rules/" target="_blank" class="link-styles">「利用規約」</a>
                    、
                    <a href="https://www.livedoor.com/privacy/" target="_blank" class="link-styles">「プライバシーポリシー」</a>
                    を必ずご確認頂き、同意の上、お申込ください。
                </div>
            </div>

            <!-- 同意チェック -->
            <div>
                <label for="agreement" class="inline-flex items-center cursor-pointer space-x-1 p-4 border rounded transition-colors duration-200" :class="isAgreed ? 'bg-emerald-50 border-emerald-800' : 'bg-base border-gray-100'">
                    <input type="checkbox" id="agreement" v-model="isAgreed" class="sr-only" />
                    <i class="fa-solid fa-square-check text-xl transition-colors duration-200" :class="isAgreed ? 'text-emerald-800' : 'text-gray-200'"></i>
                    <span class="text-left">上記の内容を確認し、同意します</span>
                </label>
            </div>

            <button @click="createAccount" class="w-full text-center btn-lg" type="button" :disabled="!isAgreed || isSaving" :class="[isAgreed && !isSaving ? 'btn-primary text-white': 'disabled:btn-disabled disabled:btn-lg']">アカウントを作成する
            </button>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import axios from 'axios';
import ErrorMessage from './ErrorMessage';

const store = useStore();
const router = useRouter();
const isAgreed = ref(false);
const isSaving = ref(false);
const errorMessage = ref("");

// アカウント作成処理
async function createAccount() {
    if (!isAgreed.value || isSaving.value) {
        return; // 既に保存処理中、未同意の場合は何もしない
    }
    isSaving.value = true; // 保存処理を開始するときにボタンを無効化

    // APIリクエスト
    try {
        const apiEndpoint = process.env.VUE_APP_API_ENDPOINT;
        const payload = {
            email: store.state.email,
            token: store.state.token,
            guidelineup: process.env.VUE_APP_GUIDELINE_UPDATE,
            action: 'create',
        };
        const response = await axios.post(`${apiEndpoint}/user-auth/`, payload, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (response.status === 200) {
            console.log('Account created successfully', response.data);
            // 成功処理
            await store.dispatch('login', { // 状態の更新が含まれるためawaitを使用
                user_id: response.data.user_id,
                accessToken: response.data.accessToken,
                expiry: response.data.expiry,
                guideline: JSON.stringify(response.data.userConsent)
            });
            await store.dispatch('clearregisterdata');
            router.push({
                name: 'AccountCreated'
            });
        } else {
            console.error('Failed to create account', response);
        }
    } catch (error) {
        console.error('Error creating account', error);
        errorMessage.value = 'アカウントの作成に失敗しました。';
    } finally {
        isSaving.value = false; // 処理が完了したらボタンを再び有効化
    }
}
</script>
